import axios from "axios";
import { httpClient } from "./http-client";
import { Parameter, ParameterValue } from "../common/types/parameters";
import { ModuleInfo } from "../common/types/modules";

let calculateOutputAbortController: AbortController | undefined;

export type CalculationAbortedResult = undefined;
export type ModuleCalculationResult = Parameter[] | CalculationAbortedResult;

export const wasCalculationAborted = (
  result: ModuleCalculationResult
): result is CalculationAbortedResult => result === undefined;

export const getModules = async (
  customer: string | undefined,
  economicProfile: string | undefined
): Promise<ModuleInfo[]> => {
  const response = await httpClient.get(
    `customers/${customer}/modules/economic-profile/${economicProfile}`
  );
  return response.data;
};

export const calculateOutput = async (
  module: string,
  input: ParameterValue[],
  customer: string | undefined,
  economicProfile: string | undefined
): Promise<ModuleCalculationResult> => {
  calculateOutputAbortController?.abort();

  const abortController = new AbortController();
  calculateOutputAbortController = abortController;

  try {
    const response = await httpClient.post(
      `customers/${customer}/modules/${module}/economic-profile/${economicProfile}/results`,
      input,
      { signal: abortController.signal }
    );
    return response.data;
  } catch (error) {
    if (axios.isCancel(error)) {
      return undefined as CalculationAbortedResult;
    }

    throw error;
  } finally {
    if (calculateOutputAbortController === abortController) {
      calculateOutputAbortController = undefined;
    }
  }
};
